import * as React from "react";
import { createPageUrl } from "../../utils";

const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={createPageUrl(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
        variant === "default" && "bg-gray-200 text-gray-900",
        variant === "secondary" && "bg-gray-100 text-gray-600",
        className
      )}
      {...props}
    />
  );
});

Badge.displayName = "Badge";

export { Badge };
